<template>
  <el-config-provider :locale="locale" namespace="el">
    <router-view />
    <div style="position:fixed;text-align:center;bottom:0;margin:0 auto;width:100%;color: #a8abb2">
      <a target="_blank" style="color: #a8abb2" href="https://beian.miit.gov.cn">津ICP备2024010927号-1</a>
    </div>
  </el-config-provider>
</template>

<script>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

export default {
  name: "App",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  data() {
    return {
      locale: zhCn,
    }
  },
  mounted() {
    this.applyDarkTheme()
  },
  methods: {
    applyDarkTheme() {
      document.body.classList.add('dark-theme')
    }
  }
}
</script>

<style>
/* 重置所有背景和文字颜色 */
body.dark-theme {
  background-color: #0a0a0a;
  color: rgba(245, 221, 6, 0.8);
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

#app {
  background-color: #0a0a0a;
  min-height: 100vh;
}

/* ===== 修复左侧菜单栏 ===== */
body.dark-theme .el-menu {
  background-color: #141414 !important;
  border-right: none;
}

body.dark-theme .el-menu-item {
  background-color: #141414 !important;
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-menu-item:hover {
  background-color: #1d1d1d !important;
}

body.dark-theme .el-menu-item.is-active {
  background-color: #409eff !important;
  color: #ffffff !important;
}

body.dark-theme .el-submenu__title {
  background-color: #141414 !important;
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-submenu__title:hover {
  background-color: #1d1d1d !important;
}

/* ===== 修复表格样式 ===== */
body.dark-theme .el-table {
  background-color: #141414 !important;
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-table th {
  background-color: #1d1d1d !important;
  color: rgba(245, 221, 6, 0.8) !important;
  border-bottom: 1px solid #434343 !important;
}

body.dark-theme .el-table td {
  background-color: #141414 !important;
  color: rgba(245, 221, 6, 0.8) !important;
  border-bottom: 1px solid #434343 !important;
}

body.dark-theme .el-table tr {
  background-color: #141414 !important;
}

body.dark-theme .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #1a1a1a !important;
}

body.dark-theme .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #2a2a2a !important;
}

/* ===== 修复表单和按钮 ===== */
body.dark-theme .el-card {
  background-color: #141414 !important;
  border: 1px solid #434343 !important;
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-form-item__label {
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-input__inner {
  background-color: #1d1d1d !important;
  border: 1px solid #434343 !important;
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-button {
  background-color: #1d1d1d !important;
  border-color: #434343 !important;
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #ffffff !important;
}

/* ===== 修复分页组件 ===== */
body.dark-theme .el-pagination {
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-pager li {
  background-color: #1d1d1d !important;
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-pager li.active {
  background-color: #409eff !important;
  color: #ffffff !important;
}

body.dark-theme .el-pagination .btn-prev,
body.dark-theme .el-pagination .btn-next {
  background-color: #1d1d1d !important;
  color: rgba(245, 221, 6, 0.8) !important;
  border: 1px solid #434343 !important;
}

/* ===== 修复下拉选择框 ===== */
body.dark-theme .el-select-dropdown {
  background-color: #1d1d1d !important;
  border: 1px solid #434343 !important;
}

body.dark-theme .el-select-dropdown__item {
  color: rgba(245, 221, 6, 0.8) !important;
}

body.dark-theme .el-select-dropdown__item.hover,
body.dark-theme .el-select-dropdown__item:hover {
  background-color: #2a2a2a !important;
}

/* ===== 修复对话框 ===== */
body.dark-theme .el-dialog {
  background-color: #141414 !important;
  border: 1px solid #434343 !important;
}

body.dark-theme .el-dialog__title {
  color: rgba(245, 221, 6, 0.8) !important;
}

/* ===== 确保所有文字可见 ===== */
body.dark-theme * {
  color: rgba(245, 221, 6, 0.8) !important;
}

/* 特殊处理，确保白色背景上的文字也能看清 */
body.dark-theme .el-table .cell {
  color: rgba(245, 221, 6, 0.8) !important;
}

/* 滚动条样式 */
body.dark-theme::-webkit-scrollbar {
  width: 8px;
}

body.dark-theme::-webkit-scrollbar-track {
  background: #1d1d1d;
}

body.dark-theme::-webkit-scrollbar-thumb {
  background: #434343;
  border-radius: 4px;
}

body.dark-theme::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* ===== 修复 Message 消息提示样式 ===== */
body.dark-theme .el-message {
  background-color: #1d1d1d !important;
  border: 1px solid #434343 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5) !important;
  min-width: 380px !important;
}

body.dark-theme .el-message__content {
  color: #e5eaf3 !important;
  font-size: 14px !important;
}

body.dark-theme .el-message__icon {
  color: inherit !important;
}

/* 成功消息样式 */
body.dark-theme .el-message--success {
  background-color: #1d1d1d !important;
  border-color: #67c23a !important;
}

body.dark-theme .el-message--success .el-message__content {
  color: #67c23a !important;
}

body.dark-theme .el-message--success .el-icon {
  color: #67c23a !important;
}

/* 错误消息样式 */
body.dark-theme .el-message--error {
  background-color: #1d1d1d !important;
  border-color: #f56c6c !important;
}

body.dark-theme .el-message--error .el-message__content {
  color: #f56c6c !important;
}

body.dark-theme .el-message--error .el-icon {
  color: #f56c6c !important;
}

/* 警告消息样式 */
body.dark-theme .el-message--warning {
  background-color: #1d1d1d !important;
  border-color: #e6a23c !important;
}

body.dark-theme .el-message--warning .el-message__content {
  color: #e6a23c !important;
}

body.dark-theme .el-message--warning .el-icon {
  color: #e6a23c !important;
}

/* 信息消息样式 */
body.dark-theme .el-message--info {
  background-color: #1d1d1d !important;
  border-color: #909399 !important;
}

body.dark-theme .el-message--info .el-message__content {
  color: #909399 !important;
}

body.dark-theme .el-message--info .el-icon {
  color: #909399 !important;
}

/* ===== 修复 Notification 通知样式（如果需要） ===== */
body.dark-theme .el-notification {
  background-color: #1d1d1d !important;
  border: 1px solid #434343 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5) !important;
}

body.dark-theme .el-notification__title {
  color: #e5eaf3 !important;
}

body.dark-theme .el-notification__content {
  color: #a8abb2 !important;
}

body.dark-theme .el-notification__icon {
  color: inherit !important;
}

/* 成功通知 */
body.dark-theme .el-notification--success {
  border-color: #67c23a !important;
}

body.dark-theme .el-notification--success .el-notification__icon {
  color: #67c23a !important;
}

/* 错误通知 */
body.dark-theme .el-notification--error {
  border-color: #f56c6c !important;
}

body.dark-theme .el-notification--error .el-notification__icon {
  color: #f56c6c !important;
}

/* ===== 修复 Loading 加载样式 ===== */
body.dark-theme .el-loading-mask {
  background-color: rgba(10, 10, 10, 0.8) !important;
}

body.dark-theme .el-loading-spinner .el-loading-text {
  color: #e5eaf3 !important;
}

body.dark-theme .el-loading-spinner .path {
  stroke: #409eff !important;
}

/* ===== 修复 MessageBox 消息框样式 ===== */
body.dark-theme .el-message-box {
  background-color: #141414 !important;
  border: 1px solid #434343 !important;
  border-radius: 8px !important;
}

body.dark-theme .el-message-box__header {
  border-bottom: 1px solid #434343 !important;
  padding: 15px 20px !important;
}

body.dark-theme .el-message-box__title {
  color: #e5eaf3 !important;
  font-size: 16px !important;
}

body.dark-theme .el-message-box__content {
  background-color: #141414 !important;
  color: #e5eaf3 !important;
  padding: 20px !important;
}

body.dark-theme .el-message-box__message {
  color: #e5eaf3 !important;
}

body.dark-theme .el-message-box__btns {
  border-top: 1px solid #434343 !important;
  padding: 15px 20px !important;
}



/* ===== 修复表格边框线颜色 ===== */
body.dark-theme .el-table {
  border: 1px solid #434343 !important;
}

body.dark-theme .el-table th,
body.dark-theme .el-table td {
  border-bottom: 1px solid #434343 !important;
  border-right: 1px solid #434343 !important;
}

body.dark-theme .el-table th {
  border-top: 1px solid #434343 !important;
}

body.dark-theme .el-table::before {
  background-color: #434343 !important;
}

body.dark-theme .el-table--border::after,
body.dark-theme .el-table--group::after {
  background-color: #434343 !important;
}

body.dark-theme .el-table--border {
  border: 1px solid #434343 !important;
  border-right: none !important;
  border-bottom: none !important;
}

body.dark-theme .el-table--border .el-table-column--selection .cell {
  border-right: 1px solid #434343 !important;
}


/* ===== 修复下拉选择框多选备选内容底色 ===== */
body.dark-theme .el-select-dropdown {
  background-color: #1d1d1d !important;
  border: 1px solid #434343 !important;
}

body.dark-theme .el-select-dropdown__item {
  background-color: #1d1d1d !important;
  color: #e5eaf3 !important;
}

body.dark-theme .el-select-dropdown__item.hover,
body.dark-theme .el-select-dropdown__item:hover {
  background-color: #2a2a2a !important;
}

body.dark-theme .el-select-dropdown__item.selected {
  background-color: #409eff !important;
  color: #ffffff !important;
}

body.dark-theme .el-select-dropdown__empty {
  color: #a8abb2 !important;
  background-color: #1d1d1d !important;
}

body.dark-theme .el-select-dropdown__wrap {
  background-color: #1d1d1d !important;
}

/* 修复多选标签样式 */
body.dark-theme .el-select__tags {
  background-color: #1d1d1d !important;
}

body.dark-theme .el-tag {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #ffffff !important;
}

body.dark-theme .el-tag .el-tag__close {
  color: #ffffff !important;
  background-color: transparent !important;
}

body.dark-theme .el-tag .el-tag__close:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
}

/* 修复选择框输入框背景 */
body.dark-theme .el-select .el-input__inner {
  background-color: #1d1d1d !important;
  border-color: #434343 !important;
  color: #e5eaf3 !important;
}

/* 修复选择框图标颜色 */
body.dark-theme .el-select .el-input__suffix {
  color: #a8abb2 !important;
}

body.dark-theme .el-select .el-input__suffix:hover {
  color: #409eff !important;
}

/* 全局覆盖Element Plus的CSS变量 */
body.dark-theme {
  /* 折叠面板相关变量 */
  --el-collapse-header-bg-color: #1d1d1d;
  --el-collapse-color: #f5dd06;
  --el-collapse-border-color: #ddd;
  --el-collapse-header-font-size: 16px;
  --el-collapse-header-height: 48px;

  /* 颜色变量 */
  --el-color-white: #1d1d1d;
  --el-color-black: #000000;
  --el-bg-color: #000000;
  --el-bg-color-page: #0a0a0a;
  --el-text-color-primary: #f5dd06;
  --el-text-color-regular: #a8abb2;

  /* 边框颜色 */
  --el-border-color-light: #434343;
  --el-border-color-lighter: #333;
  --el-border-color-extra-light: #ddd;
}
</style>

